class GalleryCompare extends HTMLElement {
    constructor() {
        super();
        
        this.isDragging = false;
        this.boundaryLower = this.getBoundingClientRect().left;
        this.boundaryUpper = this.getBoundingClientRect().width;

        this.eventsUp = ['mouseup', 'touchend'];
        this.eventsDown = ['mousedown', 'touchstart'];
        this.eventsMove = ['mousemove', 'touchmove'];

        this.foreground = this.querySelector('.gallery-compare__foreground');
        this.separator = this.querySelector('.gallery-compare__separator');
        this.thumb = this.querySelector('.gallery-compare__separator-thumb');
    };

    connectedCallback() {
        this.attachEventListeners();
    };

    attachEventListeners() {
        this.eventsDown.forEach(eventName => {
            this.thumb.addEventListener(eventName, () => {
                if(this.isDragging) return;
                this.isDragging = true;
                this.boundaryLower = this.getBoundingClientRect().left;
                this.boundaryUpper = this.getBoundingClientRect().width;                
            })
        });

        this.eventsUp.forEach(eventName => {
            document.addEventListener(eventName, () => {
                if(!this.isDragging) return;
                this.isDragging = false;                
            })
        });

        this.eventsMove.forEach(eventName => {
            document.addEventListener(eventName, event => {
                requestAnimationFrame(() => {
                    if(!this.isDragging) return;

                    const clientX = eventName === 'touchmove' ? event.touches[0].clientX : event.clientX;
                    const positionRaw = ((clientX - this.boundaryLower) / this.boundaryUpper) * 100;
                    const position = Math.min(100, Math.max(0, positionRaw));

                    this.updatePositions(position)
                })
            })
        });
    };

    updatePositions(position) {
        this.foreground.style.width = `${position}%`;
        this.separator.style.left = `${position}%`;
    }
}

if(!customElements.get('gallery-compare')) customElements.define('gallery-compare', GalleryCompare);